import KeyNamePair from '@/data/KeyNamePair';

export default class SortTypes {

  private static _types = [
    new KeyNamePair('std', 'corptube.sort.default'),
    new KeyNamePair('date', 'corptube.sort.date'),
    new KeyNamePair('name', 'corptube.sort.name'),
    new KeyNamePair('views', 'corptube.sort.views')
  ];

  public static hasKey(key: string): boolean {
    for(const pair of SortTypes._types) {
      if(key === pair.key) {
        return true;
      }
    }
    return false;
  }

  public static getKey(value: string) {
    for(const pair of SortTypes._types) {
      if(value === pair.name) {
        return pair.key;
      }
    }
    throw new Error(`No type for ${value} exists.`);
  }

  public static getValue(key: string) {
    for(const pair of SortTypes._types) {
      if(key === pair.key) {
        return pair.name;
      }
    }
  }

  public static get types() {
    return SortTypes._types;
  }

}
